import { formatUOSNumber } from './panelNumbers';

// A physical or logical UOS panel owns exactly one switch. Hide panels already
// selected by another row so the form cannot create a duplicate assignment.
export const availableUOSPanels = (panels, switches, currentSwitchIdx) => {
  const usedByOtherSwitches = new Set(
    (switches ?? [])
      .filter((eachSwitch, idx) => idx !== currentSwitchIdx && eachSwitch?.UOS)
      .map((eachSwitch) => formatUOSNumber(eachSwitch.UOS)),
  );

  return (panels ?? []).filter(
    (panel) => !usedByOtherSwitches.has(formatUOSNumber(panel)),
  );
};

